import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { FileUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { Grid, TextField } from '@material-ui/core'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { useDocumentListingLazyQuery } from 'generated/graphql'
import { amtNumStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as yup from 'yup'

export const AssetsRegisterAddInfoComponent = (props: any) => {
  const {
    openAdditonalInfo,
    editData,
    formMode,
    detailMode,
    menu,
    CompanyID,
    AssetsRegistrationID,
    listEl,
    additionalInfoData,
    latestOpenPeriodCheckingDate,
    fetchSelectedAccountPeriod,
    setOpenAdditionalInfo,
    setAdditionalInfoData,
    setIsAdditionalInformation,
  } = props

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  let form, mode, isPreviewMode
  switch (detailMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      isPreviewMode = false
      break
    case 'edit':
      form = 'Edit'
      mode = 'edit'
      isPreviewMode = false
      break
    case 'preview':
      form = 'Preview'
      mode = 'preview'
      isPreviewMode = true
      break
    default:
      form = 'New'
      mode = 'add'
      isPreviewMode = false
  }

  const defaultValues = listEl?.reduce((acc, item) => {
    const fieldName = item.name.replace(/\s+/g, '_').toLowerCase()
    acc[fieldName] = ''
    return acc
  }, {})

  const initialValidation = () => {
    if (isPreviewMode) {
      return {}
    }

    const validation = {}
    listEl?.forEach(field => {
      const FieldName = field.name.replace(/\s+/g, '_').toLowerCase()
      validation[FieldName] = field.is_require
        ? yup.string().required(`${FieldName} is required`)
        : yup.string().notRequired()
    })
    return validation
  }

  const AddInfoFormSchema = yup.object().shape(initialValidation())

  const {
    register,
    handleSubmit,
    control,
    errors,
    watch,
    setValue,
    reset,
  } = useForm({
    defaultValues: defaultValues,
    mode: 'onSubmit',
    resolver: isPreviewMode ? undefined : yupResolver(AddInfoFormSchema),
  })
  const [additionalInformationAmt, setAdditionalInformationAmt] = useState(
    amtNumStr(AssetsRegistrationID && editData?.AdditionalInformation) ?? 0
  )
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    fetchDocuments,
    { loading: documentLoading, data: DocData },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (isMounted.current && !editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (
      (detailMode === 'edit' || detailMode === 'preview') &&
      openAdditonalInfo &&
      additionalInfoData?.length > 0 &&
      isMounted.current
    ) {
      const existingDataMap = {}
      additionalInfoData.forEach(item => {
        const fieldName = item.Name.replace(/\s+/g, '_').toLowerCase()
        existingDataMap[fieldName] = item
      })

      listEl?.forEach(field => {
        const fieldName = field.name.replace(/\s+/g, '_').toLowerCase()
        const existingData = existingDataMap[fieldName]

        if (
          existingData &&
          existingData.value !== null &&
          existingData.value !== undefined
        ) {
          if (field.data_type === 'DATE') {
            setValue(fieldName, new Date(existingData.value))
          } else if (field.data_type === 'NUMBER') {
            setValue(fieldName, existingData.value)
            setAdditionalInformationAmt(existingData.value)
          } else {
            setValue(fieldName, existingData.value)
          }
        }
      })
    }
  }, [detailMode, openAdditonalInfo, additionalInfoData, listEl, setValue])

  useEffect(() => {
    if (openAdditonalInfo && isMounted.current && !isPreviewMode) {
      listEl?.forEach(field => {
        if (field?.data_type === 'DATE') {
          const fieldName = field.name.replace(/\s+/g, '_').toLowerCase()
          const existingData = additionalInfoData?.find(
            item => item.Name === field.name
          )

          if (existingData?.value) {
            setValue(fieldName, new Date(existingData.value))
          } else {
            setValue(fieldName, new Date())
          }
        }
      })
    }
  }, [openAdditonalInfo, listEl, additionalInfoData, setValue, isPreviewMode])

  useEffect(() => {
    if (
      (formMode === 'edit' ||
        formMode === 'approve-reject' ||
        formMode === 'resubmit') &&
      !!!editData?.files &&
      isMounted.current
    ) {
      fetchDocuments({
        variables: {
          refID: AssetsRegistrationID,
        },
      })
    }
  }, [formMode])

  useEffect(() => {
    if (editData?.files && isMounted.current) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [editData])

  const onSubmit = (data: any, mode: string, index: number) => {
    if (!isMounted.current || isPreviewMode) return

    const formattedDataArray: {
      Name: string
      is_subgroup: boolean | null
      sequence_no: number | null
      value: any
      data_type: string | null
      control_type: string | null
      fa_fields_setting_detail_id: string
      fa_additional_fields_value_detail_id?: string
      fa_additional_fields_value_id?: string
    }[] = []

    listEl?.forEach(item => {
      const fieldName = item.name.replace(/\s+/g, '_').toLowerCase()
      const fieldValue = data[fieldName]

      const existingFieldData =
        detailMode === 'edit'
          ? additionalInfoData?.find(existing => existing.Name === item.name)
          : null

      formattedDataArray.push({
        Name: item.name,
        sequence_no: item.sequence_no,
        value: fieldValue !== undefined ? fieldValue : '',
        is_subgroup: item.is_subgroup,
        data_type: item.data_type,
        control_type: item.control_type,
        fa_fields_setting_detail_id: item.fa_fields_setting_detail_id,
        fa_additional_fields_value_detail_id:
          existingFieldData?.fa_additional_fields_value_detail_id,
        fa_additional_fields_value_id:
          existingFieldData?.fa_additional_fields_value_id,
      })
    })

    if (detailMode === 'edit') {
      setAdditionalInfoData(formattedDataArray)
    } else {
      setAdditionalInfoData([...additionalInfoData, ...formattedDataArray])
    }

    setOpenAdditionalInfo(false)
  }

  return (
    <>
      {documentLoading && <Loading />}
      <CommonDialog
        fullWidth={true}
        open={openAdditonalInfo}
        onClose={() => {
          if (isMounted.current) {
            setOpenAdditionalInfo(false)
          }
        }}
        sections={{
          header: {
            title: 'Additional Information',
            rightText: form,
          },
          body: () => (
            <>
              <CardContents>
                {listEl
                  ?.sort(function(a, b) {
                    return a?.sequence_no < b?.sequence_no ? -1 : 1
                  })
                  ?.map((infoData, index) => {
                    const FieldName = infoData.name
                      .replace(/\s+/g, '_')
                      .toLowerCase()

                    const existingData =
                      detailMode === 'edit' || detailMode === 'preview'
                        ? additionalInfoData?.find(
                            item => item.Name === infoData.name
                          )
                        : null

                    const style = {
                      fontWeight: infoData.is_bold === true ? 'bold' : 'normal',
                      textDecoration:
                        infoData.is_underline === true ? 'underline' : 'none',
                      fontStyle:
                        infoData.is_italic === true ? 'italic' : 'normal',
                    }

                    return (
                      <Fragment key={infoData.fa_fields_setting_detail_id}>
                        {infoData?.is_subgroup === true ? (
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <span style={style}>{infoData?.name}</span>
                              {!isPreviewMode && (
                                <input
                                  type="hidden"
                                  name={`${FieldName}`}
                                  value={infoData?.name}
                                  ref={register}
                                />
                              )}
                            </Grid>
                          </Grid>
                        ) : infoData?.data_type === 'DATE' ? (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Controller
                              as={KeyboardDatePicker}
                              name={FieldName}
                              label={infoData.name}
                              control={control}
                              ref={register}
                              defaultValue={
                                existingData?.value
                                  ? new Date(existingData.value)
                                  : new Date()
                              }
                              allowKeyboardControl
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              showTodayButton
                              margin="dense"
                              minDate={
                                !isPreviewMode &&
                                latestOpenPeriodCheckingDate?.StartDate
                                  ? new Date(
                                      latestOpenPeriodCheckingDate.StartDate
                                    )
                                  : undefined
                              }
                              maxDate={
                                !isPreviewMode &&
                                latestOpenPeriodCheckingDate?.EndDate
                                  ? new Date(
                                      latestOpenPeriodCheckingDate.EndDate
                                    )
                                  : undefined
                              }
                              value={watch(FieldName) || new Date()}
                              format="dd/MM/yyyy"
                              required={!isPreviewMode && infoData.is_require}
                              helperText={
                                !isPreviewMode &&
                                infoData.is_require &&
                                errors[FieldName]
                                  ? `${infoData.name} is required`
                                  : null
                              }
                              error={
                                !isPreviewMode && errors[FieldName]
                                  ? true
                                  : false
                              }
                              disabled={isPreviewMode}
                              readOnly={isPreviewMode}
                            />
                          </MuiPickersUtilsProvider>
                        ) : infoData?.data_type === 'NUMBER' ? (
                          <Controller
                            as={<NumberFormat />}
                            customInput={TextField}
                            key={infoData.fa_fields_setting_detail_id}
                            id={`standard-basic-${infoData.fa_fields_setting_detail_id}`}
                            name={FieldName}
                            label={infoData.name}
                            autoComplete="off"
                            control={control}
                            ref={register}
                            defaultValue={existingData?.value || 0}
                            onValueChange={e => {
                              if (!isPreviewMode) {
                                setValue(FieldName, e.value)
                                setAdditionalInformationAmt(e.value)
                              }
                            }}
                            thousandSeparator
                            decimalScale={infoData?.decimal_type}
                            fixedDecimalScale
                            margin="normal"
                            helperText={
                              !isPreviewMode &&
                              infoData.is_require &&
                              errors[FieldName]
                                ? `${infoData.name} is required`
                                : null
                            }
                            error={
                              !isPreviewMode && errors[FieldName] ? true : false
                            }
                            required={!isPreviewMode && infoData.is_require}
                            disabled={isPreviewMode}
                            InputProps={
                              isPreviewMode ? { readOnly: true } : undefined
                            }
                          />
                        ) : infoData?.data_type === 'ATTACHMENT' ? (
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <FileUploadInput
                                label={infoData.name}
                                files={files}
                                onHandleUploadChange={handleUploadChange}
                                multiple
                                imagePreview={
                                  <>
                                    {previewFiles?.map((v, i) => (
                                      <UploadPreview
                                        remove
                                        key={v}
                                        src={v}
                                        onClick={() => removeFile(i)}
                                        mediaType={files[i]?.type}
                                      />
                                    ))}
                                  </>
                                }
                              />
                              {!isPreviewMode && infoData.is_require && (
                                <input
                                  type="hidden"
                                  name={`${FieldName}`}
                                  ref={register}
                                />
                              )}
                            </Grid>
                          </Grid>
                        ) : infoData?.control_type === 'MULTI_LINE_TEXT_BOX' ||
                          infoData?.control_type === 'MULTIPLE_ROW_TEXT' ||
                          infoData?.control_type === 'MULTI_LINE_TEXT' ? (
                          <Controller
                            as={TextField}
                            key={infoData.fa_fields_setting_detail_id}
                            id={`standard-basic-${infoData.fa_fields_setting_detail_id}`}
                            name={FieldName}
                            label={infoData.name}
                            autoComplete="off"
                            control={control}
                            ref={register}
                            defaultValue={existingData?.value || ''}
                            multiline={true}
                            // rows={4}
                            fullWidth
                            margin="dense"
                            helperText={
                              !isPreviewMode &&
                              infoData.is_require &&
                              errors[FieldName]
                                ? `${infoData.name} is required`
                                : null
                            }
                            error={
                              !isPreviewMode && errors[FieldName] ? true : false
                            }
                            required={!isPreviewMode && infoData.is_require}
                            disabled={
                              isPreviewMode || formMode === 'approve-reject'
                            }
                            InputProps={
                              isPreviewMode ? { readOnly: true } : undefined
                            }
                          />
                        ) : infoData?.data_type === 'TEXT' ||
                          infoData?.control_type === 'TEXT_BOX' ||
                          infoData?.control_type === 'TEXT' ? (
                          <Controller
                            as={TextField}
                            key={infoData.fa_fields_setting_detail_id}
                            id={`standard-basic-${infoData.fa_fields_setting_detail_id}`}
                            name={FieldName}
                            label={infoData.name}
                            autoComplete="off"
                            control={control}
                            ref={register}
                            defaultValue={existingData?.value || ''}
                            fullWidth
                            margin="dense"
                            helperText={
                              !isPreviewMode &&
                              infoData.is_require &&
                              errors[FieldName]
                                ? `${infoData.name} is required`
                                : null
                            }
                            error={
                              !isPreviewMode && errors[FieldName] ? true : false
                            }
                            required={!isPreviewMode && infoData.is_require}
                            disabled={isPreviewMode}
                            InputProps={
                              isPreviewMode ? { readOnly: true } : undefined
                            }
                          />
                        ) : (
                          // Fallback for any unhandled field type
                          <Controller
                            as={TextField}
                            key={infoData.fa_fields_setting_detail_id}
                            id={`standard-basic-${infoData.fa_fields_setting_detail_id}`}
                            name={FieldName}
                            label={`${infoData.name} (Type: ${infoData.data_type} / Control: ${infoData.control_type})`}
                            autoComplete="off"
                            control={control}
                            ref={register}
                            defaultValue={existingData?.value || ''}
                            fullWidth
                            margin="dense"
                            helperText={
                              !isPreviewMode &&
                              infoData.is_require &&
                              errors[FieldName]
                                ? `${infoData.name} is required`
                                : null
                            }
                            error={
                              !isPreviewMode && errors[FieldName] ? true : false
                            }
                            required={!isPreviewMode && infoData.is_require}
                            disabled={isPreviewMode}
                            InputProps={
                              isPreviewMode ? { readOnly: true } : undefined
                            }
                          />
                        )}
                      </Fragment>
                    )
                  })}
              </CardContents>

              <ErrorDialog
                errorDia={errorDia}
                setErrorDia={setErrorDia}
                errorMsg={errMsg}
                errorHeaderMsg={'Error!'}
              />
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => {
                    if (isMounted.current) {
                      setOpenAdditionalInfo(false)
                    }
                  },
                  variant: 'contained' as 'contained',
                  color: 'primary' as 'primary',
                },
              },
              ...(isPreviewMode
                ? []
                : [
                    {
                      displayText: 'Confirm',
                      props: {
                        onClick: () => {
                          handleSubmit(data =>
                            onSubmit(data, 'save', menu?.index)
                          )()
                        },
                        variant: 'contained' as 'contained',
                        color: 'primary' as 'primary',
                      },
                    },
                  ]),
            ],
          },
        }}
      />
    </>
  )
}
